import { getAnalytics, logEvent } from "firebase/analytics";
import { initializeApp } from "firebase/app";
import { analytics } from "./firebaseConfig";

// ———————————————————————————————————————————
// if Firebase is already initialised elsewhere just
// import the analytics instance; otherwise, do it here
// ———————————————————————————————————————————

/**
 * Log a user interaction with the OFSC podcast.
 *
 * @param {Object}   p
 * @param {string}   p.action         – “Play” | “Pause” | “Next” | “Previous” | “Seek” | “CTA”
 * @param {string}   p.cta            – Button label or “progress-bar”
 * @param {string}   p.chapter        – Chapter title at the time of the click
 */
export function logPodcastAction({ platform, action, cta = "", chapter = "", node = "", param_lang = "", podcast }) {
  logEvent(analytics, "podcast_action", {
    timestamp: Date.now(),
    platform,
    action,
    cta,
    chapter,
    node,
    param_lang,
    podcast,
  });
}

/**
 * Generic helper for logging Landing Page v2 interactions with consistent metadata.
 *
 * @param {Object}  params
 * @param {string}  params.event       - Event name to log (e.g., "landing_nav_click").
 * @param {string}  [params.section]   - Page section associated with the event.
 * @param {string}  [params.label]     - UI label or CTA text.
 * @param {Object}  [params.metadata]  - Additional key/value metadata for deeper analysis.
 */
export function logLandingEvent({ event, section = "", label = "", metadata = {} }) {
  if (!event) {
    return;
  }

  logEvent(analytics, event, {
    timestamp: Date.now(),
    section,
    label,
    ...metadata,
  });
}

export function logAnalyticsDashboardView({ podcastId, pagePath }) {
  if (!podcastId) {
    return;
  }

  logEvent(analytics, "analytics_dashboard_view", {
    timestamp: Date.now(),
    podcast_id: podcastId,
    page_path: pagePath || `/analytics/${podcastId}`,
  });
}

export function logAnalyticsDashboardFilter({
  podcastId,
  filterType,
  action,
  value = "",
  selectedCount = 0,
  totalCount = 0,
}) {
  if (!podcastId || !filterType || !action) {
    return;
  }

  logEvent(analytics, "analytics_dashboard_filter", {
    timestamp: Date.now(),
    podcast_id: podcastId,
    filter_type: filterType,
    action,
    value,
    selected_count: selectedCount,
    total_count: totalCount,
  });
}

export function logAnalyticsDashboardMapLayerToggle({
  podcastId,
  layer,
  checked,
}) {
  if (!podcastId || !layer) {
    return;
  }

  logEvent(analytics, "analytics_dashboard_map_layer", {
    timestamp: Date.now(),
    podcast_id: podcastId,
    layer,
    checked,
  });
}
